define(["marionette", "./template/redactSurveyCommentModalTemplate.html"], function (
  Marionette,
  RedactSurveyCommentModalTemplate,
) {
  "use strict";

  const RedactSurveyCommentModalView = {};

  RedactSurveyCommentModalView.view = Marionette.ItemView.extend({
    template: RedactSurveyCommentModalTemplate,
    className: "redact-survey-comment-modal",
    events: {
      "select #comment": "select",
    },
    triggers: {
      "click #cancelButton": "cancel",
      "submit form": "done",
    },
    select: function (e) {
      this.trigger("select", e.target.selectionStart, e.target.selectionEnd);
    },
  });

  return RedactSurveyCommentModalView;
});
